import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from 'i2g-ng-utils';

export const ACCOUNT_SCHEMA = Object.freeze({
  ACCOUNT_ID: '',
  ACCESS_TOKEN: '',
  REFRESH_TOKEN: '',
  USER_ID: '',
});

const RECORD = generateSchema(ACCOUNT_SCHEMA);
const KEYS: any = generateKeys(ACCOUNT_SCHEMA);

export class Account extends Record(RECORD) {
  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});
    super(props);
  }

  get accountId(): string {
    return this.get(KEYS.ACCOUNT_ID);
  }

  get accessToken(): string {
    return this.get(KEYS.ACCESS_TOKEN);
  }

  get refreshToken(): string {
    return this.get(KEYS.REFRESH_TOKEN);
  }

  get userId(): string {
    if (this.get(KEYS.USER_ID)) {
      return this.get(KEYS.USER_ID);
    }

    const parts = this.accessToken.split('.');
    try {
      const decodedToken = JSON.parse(atob(parts[1]));
      return decodedToken.user_id;
    } catch (e) {
      return null;
    }
  }
}
